








































import VueOptions from '@utils/VueOptions'

settings =
  name: 'MeShow'
  resources:
    me: 
      resourceName: "me"
      slug: "me/:brandRepId/edit"
  vue:
    store: ['member']
    computed:
      brandRepId: -> @member.brand_rep?.id
    data: ->
      cryoMe: null
      isEditing: false
    methods:
      nevermindClicked: -> 
        @prime.me = @cryoMe
        @isEditing = false
      saveClicked: -> 
        @saveItem 'me', @prime.me
        @isEditing = false
    watch:
      isEditing: (newValue) ->
        @cryoMe = @cloneObject @prime.me
export default VueOptions.vue settings

